import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map } from "rxjs";
import { IBaseSearchRequest } from "src/app/core/models/base";
import { DeviceService } from "src/app/devices/services/device.service";

export function DeviceManufacturerValidator(deviceService: DeviceService): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        const request : IBaseSearchRequest= {
            pageNumber:0,
            pageSize: 999999,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'name',
                        operator: 'eq',
                        value: control.value
                    }
                ]
            }
        }

        return deviceService.getDeviceManufacturers(request)
        .pipe(
            map(response => {
                const deviceManufacturers = response.data;

                return deviceManufacturers.length != 0 ? {deviceManufacturerExists: true} : null;
            })
        )
    }
}
